
import searchInput from '@/components/search-input';
import divSpan from '@/components/DivSpan';
import Popup from 'vux/src/components/popup/index.vue'

import fileUpload from '@/components/file-upload';
export default {
name: "sup-type",
components:{
searchInput,
divSpan,
Popup,
fileUpload
},
data(){
return{
show: true,
config:{
url:'api/sup-supply-cat/page',
title:'供应商品类管理',
workflowSearchBean:{},
fixRules:{},
inputCondition:{
placeholder:'供应商编号/名称/品类',
searchCondition:'key',
rules:[{field: "supplier.supplierCode-supplier.supplierName-supplyType.name-supplyType.code", option: "LIKE_ANYWHERE"}]
},
selectConfig:[]
},
wrapperHeight:0,
allLoaded:false,
list:[],
supDetail:{},
showDetail:false,
userType:1
}
},
methods:{
goDetail(sup){
if(sup){
this.supDetail = sup;
this.showDetail = true;
}
},
closeQual(){
this.showDetail = false;
this.supDetail.attachment = {};
},
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function() {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop(){
this.$refs.header.getlist(true);
},
loadBottom(){
this.$refs.header.getMore();
},

},
mounted(){
this.init();
this.$refs.header.getlist();
},

}



// WEBPACK FOOTER //
// ./src/page/supplier/sup-type/sup-type.vue